import { render } from "./text-control.vue?vue&type=template&id=590b1ca9&ts=true"
import script from "./text-control.ts?vue&type=script&lang=ts&external"
export * from "./text-control.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__